import { render, staticRenderFns } from "./VerCrearModal.vue?vue&type=template&id=71ab655d&"
import script from "./VerCrearModal.vue?vue&type=script&lang=ts&"
export * from "./VerCrearModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('71ab655d', component.options)
    } else {
      api.reload('71ab655d', component.options)
    }
    module.hot.accept("./VerCrearModal.vue?vue&type=template&id=71ab655d&", function () {
      api.rerender('71ab655d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltaTecnico/VerCrearModal.vue"
export default component.exports